// extracted by mini-css-extract-plugin
module.exports = {"invoice_thumbnails":"DocumentThumb_invoice_thumbnails__2YiYt","eye_icon":"DocumentThumb_eye_icon__2l9sV"};